/** Формула расчёта Δ для тултипа potential rating (debug mode) */
export function getFormulaTooltip(
  outcome: 'win' | 'lose' | 'tie',
  P: number,
  kBase: number,
  kPop: number,
  kEarly: number,
  delta: number,
  ratingMultiplier = 1,
): string {
  const pStr = P.toFixed(2);
  const kPopStr = kPop.toFixed(2);
  const kEarlyStr = kEarly.toFixed(2);
  const multStr = ratingMultiplier !== 1 ? ` × ${ratingMultiplier}` : '';
  if (outcome === 'win') {
    return `Δ = K-base × (1 - P) × K-pop × K-early${multStr}\n= ${kBase} × (1 - ${pStr}) × ${kPopStr} × ${kEarlyStr}${multStr}\n= ${delta > 0 ? '+' : ''}${delta.toFixed(1)}`;
  }
  if (outcome === 'lose') {
    return `Δ = K-base × (0 - P) × K-pop${multStr}\n= ${kBase} × (0 - ${pStr}) × ${kPopStr}${multStr}\n= ${delta.toFixed(1)}`;
  }
  // tie: K-early только если 0.5 > P
  const useEarly = 0.5 > P;
  if (useEarly) {
    return `Δ = K-base × (0.5 - P) × K-pop × K-early${multStr}\n= ${kBase} × (0.5 - ${pStr}) × ${kPopStr} × ${kEarlyStr}${multStr}\n= ${delta > 0 ? '+' : ''}${delta.toFixed(1)}`;
  }
  return `Δ = K-base × (0.5 - P) × K-pop${multStr}\n= ${kBase} × (0.5 - ${pStr}) × ${kPopStr}${multStr}\n= ${delta.toFixed(1)}`;
}
